<template>
  <el-aside :width="(isCollapse ? '64px' : '250px')">
    <el-menu
      :default-active="activeindex"
      class="el-menu-custom"
      :collapse="isCollapse"
      background-color="#8b9095"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <div class="logo">
        <a href="/home" class="simple-text">
          <div class="logo-img">
            <img src="/static/img/logo.png" alt />
          </div>
          <span v-if="!isCollapse">Vopsa</span>
        </a>
      </div>
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-tickets"></i>
          <span slot="title">Histórico de accesos</span>
        </template>
        <el-menu-item-group>
          <span slot="title">Histórico</span>
          <el-menu-item
            index="access-history-user"
            @click="cambio('/auditoria/access-history-user')"
          >
            <i class="fa fa-users"></i>
            <span slot="title">Usuarios</span>
          </el-menu-item>
          <el-menu-item
            index="access-history-date"
            @click="cambio('/auditoria/access-history-date')"
          >
            <i class="el-icon-date"></i>
            <span slot="title">Fecha</span>
          </el-menu-item>
          <el-menu-item
            index="access-history-resumen"
            @click="cambio('/auditoria/access-history-resumen')"
          >
            <i class="fa fa-object-group"></i>
            <span slot="title">Por Página</span>
          </el-menu-item>
          <el-menu-item
            index="access-history-documents"
            @click="cambio('/auditoria/access-history-documents')"
          >
            <i class="fa fa-file-o"></i>
            <span slot="title">Por Documento</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-tickets"></i>
          <span slot="title">Histórico de notificaciones</span>
        </template>
        <el-menu-item-group>
          <span slot="title">Notificaciones</span>
          <el-menu-item index="user-notifications" @click="cambio('/auditoria/user-notifications')">
            <i class="fa fa-user"></i>
            <span slot="title">Usuario - notificaciones</span>
          </el-menu-item>
          <el-menu-item
            index="notification-users"
            @click="cambio('/auditoria/notifications-agrupadas')"
          >
            <i class="fa fa-users"></i>
            <span slot="title">Todos los usuarios</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>
<script>
import { mapGetters } from "vuex";
import { FECTH_SIDEBAR, FECTH_NAME_SIDEBAR } from "@/store/actions.type";

export default {
  name: "sidebar",
  computed: {
    ...mapGetters(["isAdmin", "currentUser"])
  },
  created() {
    window.localStorage.getItem("isCollapse") == "true"
      ? (this.isCollapse = true)
      : (this.isCollapse = false);
    this.$root.$on("toogleChange", () => {
      this.toggle();
    });
  },
  beforeDestroy() {
    this.$root.$off("toogleChange", () => {
      this.toggle();
    });
  },
  data() {
    return {
      links: null,
      table: null,
      isCollapse: false,
      activeindex: "1",
      show: false
    };
  },
  methods: {
    cambio(href, name) {
      this.$router.push(href);
    },
    toggle() {
      this.isCollapse = !this.isCollapse;
      window.localStorage.setItem("isCollapse", this.isCollapse);
    }
  }
};
</script>


<style lang="scss" scoped>
.el-aside,
.el-menu {
  min-height: calc(100vh);
}
.el-menu-custom {
  border-right: none;
}
.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    height: 1px;
    width: 90%;
    background: white;
  }
  > .simple-text {
    color: white;
    font-weight: 700;
    > .logo-img {
      max-height: 55px;
      max-width: 55px;
      display: inline-block;
      > img {
        max-width: 100%;
        padding-right: 10px;
      }
    }
  }
  .close {
    width: 64px;
  }
}

.el-menu-custom i {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/auditoria/Sidebar.vue